import * as Yup from 'yup';

export const FORM_FIELDS = {
    designation: {
        name: 'designation',
        label: 'Designation',
        placeholder: 'Ex: software developer',
    },
    aboutMe: {
        name: 'aboutMe',
        label: 'Tell us a bit about yourself',
        placeholder: '',
    },
    favoriteFood: {
        name: 'favoriteFood',
        label: 'Favourite food',
        placeholder: 'Ex: Coke, Biryani, Pasta',
    },
    languages: {
        name: 'languages',
        label: 'Languages known',
        placeholder: 'Ex: English, Hindi, Marathi',
    },
};

export const initialValues = {
    designation: '',
    aboutMe: '',
    favoriteFood: '',
    languages: '',
};

export const getValidationSchemaForIntros = (isFavFoodEnabled, isLanguagesEnabled) =>
    Yup.object().shape({
        designation: Yup.string().required('Designation is required'),
        aboutMe: Yup.string().required('About yourself is required').max(300, 'Max 300 characters'),
        favoriteFood: isFavFoodEnabled ? Yup.string().required('Favourite food is required') : Yup.string(),
        languages: isLanguagesEnabled ? Yup.string().required('Languages is required') : Yup.string(),
    });
